/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";

import { TextField } from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import backgroundImage from "assets/images/bg-profile.jpg";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MuiPhoneNumber from "material-ui-phone-number";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getCustomerProfileByID } from "utils/api";

let id = undefined;
let LOGIN_DETAILS

function CustomerProfile({ children }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [hide, sethide] = useState(false);
  const dispatch = useDispatch()
  const [values, setValues] = React.useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    phoneNumber: "",
    stateName: "",
    countryName: "",
    zipCode: "",
    streetAddress: "",
    companyName: "",
    city: "",

    // userPassword: '',
    _id: "",
  });
  const handleChange = (name) => (event) => {
    if (event.target.validity.valid) {
      setValues({ ...values, [name]: event.target.value });
    }
  };
  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    values.phoneNumber = phone.slice(country.dialCode.length);
    values.countryCode = "+" + country.dialCode;
    values.phoneNumber = values.countryCode + values.phoneNumber;
  };


  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  id = LOGIN_DETAILS._id

  useEffect(() => {
    if (id !== undefined) {
      values.customerID = id;
      fetchProfile()
    }
  }, []);

  const fetchProfile = async () => {
    getCustomerProfileByID(values, (data) => {
      if (data.Result_Status) {
        setValues(data.Result_Output[0])
      }
    }, dispatch)

  };

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);


  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox position="relative" mb={5}>
          <MDBox
            display="flex"
            alignItems="center"
            position="relative"
            minHeight="18.75rem"
            borderRadius="xl"
            sx={{
              backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
                `${linearGradient(
                  rgba(gradients.info.main, 0.6),
                  rgba(gradients.info.state, 0.6)
                )}, url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "50%",
              overflow: "hidden",
            }}
          />
          <Card
            sx={{
              position: "relative",
              mt: -8,
              mx: 3,
              py: 5,
              px: 2
            }}
          >

            <Card sx={{ boxShadow: "none", px: 3 }}>

              <Grid container columnSpacing={4} rowSpacing={2}>
                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    type="text"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    value={values.firstName}
                    onChange={handleChange("firstName")}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    type="text"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    value={values.lastName}
                    onChange={handleChange("lastName")}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    type="email"
                    label="Username(Email Address)"
                    variant="outlined"
                    fullWidth
                    value={values.emailAddress}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <MuiPhoneNumber
                    defaultCountry={"us"}
                    type="text"
                    label="Mobile Number"
                    variant="outlined"
                    fullWidth
                    value={values.phoneNumber}
                    onChange={(phone, country) => setPhoneValues(phone, country)}
                    disabled
                  />
                </Grid>
                {!hide && <>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Street Address"
                      variant="outlined"
                      fullWidth
                      value={values.streetAddress}
                      // onChange={handleChange("lastName")}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="City"
                      variant="outlined"
                      fullWidth
                      value={values.city}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Zip Code"
                      variant="outlined"
                      fullWidth
                      value={values.zipCode}
                      disabled
                    />
                  </Grid>

                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="Country"
                      variant="outlined"
                      fullWidth
                      value={values.countryName}
                      // onChange={handleChange("firstName")}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      type="text"
                      label="State"
                      variant="outlined"
                      fullWidth
                      value={values.stateName}
                      // onChange={handleChange("lastName")}
                      disabled
                    />
                  </Grid></>}



              </Grid>
              {/* <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                  <Grid item xs={12} md={6} xl={4} lg={4}></Grid>
                  <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                    <MDBox mt={0.5}></MDBox>
                    <MDBox width="80%" ml={0.5}></MDBox>
                  </MDBox>
                  <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                    <MDBox mt={0.5}></MDBox>
                    <MDBox width="80%" ml={0.5}></MDBox>
                  </MDBox>
                  <MDBox mt={3}></MDBox>
                  <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                    <MuiPhoneNumber
                      defaultCountry={"us"}
                      type="text"
                      label="Mobile Number"
                      variant="outlined"
                      fullWidth
                      value={values.phoneNumber}
                      onChange={(phone, country) => setPhoneValues(phone, country)}
                    />
                  </MDBox>
                  <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                    <MDBox mt={0.5}>
                      <FormGroup>
                        <FormControlLabel
                          control={<Checkbox onChange={resetPasswordChecked} />}
                          label="Change Password"
                        />
                      </FormGroup>
                    </MDBox>
                    <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                      
                    </MDBox>
                  </MDBox>
                </MDBox> */}

              {/* <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                <Grid item xs={12} md={6} xl={4} lg={4} sx={{ alignContent: "center" }}>
                  <MDBox p={2}>
                    <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                      My Profile
                      &nbsp;
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                    <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}></MDBox>
                    <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                      <MDBox mt={0.5}></MDBox>
                      <MDBox width="80%" ml={0.5}></MDBox>
                    </MDBox>
                    <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                      <MDBox mt={0.5}></MDBox>
                      <MDBox width="80%" ml={0.5}></MDBox>
                    </MDBox>
                    <MDBox mt={3}></MDBox>
                    <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}></MDBox>
                    <Height val={48} /> */}

              {/* <Grid
                  item
                  xs={12}
                  md={6}
                  xl={4}
                  sx={{ display: "flex", justifyContent: "center" }}
                  lg={4}
                  disabled
                >
                  <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />

                  <ProfileInfoCard
                      disabled
                      title="profile information"
                        description="Hi, I’m Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
                      info={{
                        fullName: Name,
                        mobile: values.phoneNumber,
                        email: values.emailAddress,
                        location: "USA",
                      }}
                      social={[
                        {
                          link: "https://www.facebook.com/CreativeTim/",
                          icon: <FacebookIcon />,
                          color: "facebook",
                        },
                        {
                          link: "https://twitter.com/creativetim",
                          icon: <TwitterIcon />,
                          color: "twitter",
                        },
                        {
                          link: "https://www.instagram.com/creativetimofficial/",
                          icon: <InstagramIcon />,
                          color: "instagram",
                        },
                      ]}
                      action={{ route: "", tooltip: "Edit Profile" }}
                      shadow={false}
                        route={"/editprofile"}
                    />
                  <Divider orientation="vertical" sx={{ mx: 0 }} />
                </Grid> */}

              <Grid
                container

                columnSpacing={4}
                alignItems="center"
                display="flex"
                justifyContent="center"
              >
                <Grid item xs={12} md={4} spacing={2} lg={1.2}>
                  <Link to={"/editCusProfile"}>
                    <MDButton
                      className="btn-block center-container-btn btn-warning btn-back rightSpace"
                      color="success"
                      fullWidth
                    >
                      Edit
                    </MDButton>
                  </Link>
                </Grid>
              </Grid>
            </Card>
          </Card>
        </MDBox>
      </DashboardLayout>
    </>
  );
}

// Setting default props for the Header

export default CustomerProfile;
